import AbstractComponent from "components/Abstract";
import ButtonIconSelect from "components/ButtonIconSelect";

import { ReactComponent as BanIcon } from 'icons/pages/app/ban.svg';
import { ReactComponent as DebtIcon } from 'icons/pages/app/debt.svg';
import { ReactComponent as FirstVisitIcon } from 'icons/pages/app/firstVisit.svg';
import { ReactComponent as SpecialInfoIcon } from 'icons/pages/app/specialInfo.svg';
import { ReactComponent as VipIcon } from 'icons/pages/app/vip.svg';
import { ReactComponent as VisitStatusIcon } from 'icons/pages/app/visitStatus.svg';
import { ReactComponent as VisitStatusInIcon } from 'icons/pages/app/visitStatusIn.svg';
import { ReactComponent as NorepeatIcon } from 'icons/components/norepeat.svg';

const allMins = Array(37).fill(0).map((it, i) => `mins${i * 5}`);
allMins.shift();

export default class ScheduleViewVisits extends AbstractComponent {

    visResizeStart(flag, info, e) {
        if (e.button !== 0)
            return;

        const { id, startD, endD, doctorId, cabinetId } = info;

        const nodeOrig = this.visitsNodes[id];
        const node = this._helper.dom.clone(nodeOrig);

        this._helper.dom.display(nodeOrig, 0);
        this._helper.dom.addClass(node, "editing");

        node.vStartD = startD;
        node.vEndD = endD;
        node.vLastDate = startD;
        node.vLastDateEnd = endD;
        node.vLastDoctorId = doctorId;
        node.vLastCabinetId = cabinetId;

        this.clearResize();
        this.resizeCnt = this._helper.on(window, "mousemove", this.visResizeMove.bind(this, flag, info, node));
        this.resizeEndCnt = this._helper.on(window, "mouseup", this.visResizeEnd.bind(this, info, node, nodeOrig));
        this.startY = e.pageY;
    }

    clearResize() {
        this._helper.disconnect(this.resizeCnt);
        this._helper.disconnect(this.resizeEndCnt);
        this.resizeCnt = null;
    }

    visResizeMove(flag, info, node, e) {
        this.setVizResizeStep(flag, info, node, e);
    }

    visResizeEnd(info, node, nodeOrig) {
        this.clearResize();

        const { vLastDoctorId, vLastCabinetId, vLastDate, vLastDateEnd } = node;
        const { id, doctorId, cabinetId, beginDate, endDate } = info;

        const obj = {
            doctorId: vLastDoctorId,
            cabinetId: vLastCabinetId,
            beginDate: this._helper.date.toStr(vLastDate),
            endDate: this._helper.date.toStr(vLastDateEnd),
        };

        const eaqual = (vLastDoctorId === doctorId && vLastCabinetId === cabinetId && obj.beginDate === beginDate && obj.endDate === endDate);

        if (eaqual || node.vHasIntersect) {
            node.remove();
            this._helper.dom.display(nodeOrig, 1);

            return;
        }

        this.props.updateVisit(id, obj, () => {
            node.remove();
        });
    }

    setVizResizeStep(flag, info, node, e) {
        const { id } = info;
        const { pageY, target } = e;
        const diffY = this.startY - pageY;

        const pxInInt = this.intPx * 5 / this.timeMins;
        const top = this._helper.number.roundByFloor(diffY, pxInInt) / this.intPx;
        let mins = this._helper.number.roundBy(top * this.timeMins, 5);

        let doctorNode = node.parentNode;
        let start = this._helper.date.fromStr(doctorNode.dataset.beginDateTime);
        let end = this._helper.date.fromStr(doctorNode.dataset.endDateTime);
        let startDCopy = new Date(node.vStartD.getTime());
        let endDCopy = new Date(node.vEndD.getTime());
        const diffMins = Math.abs(startDCopy.getTime() - endDCopy.getTime()) / this._helper.date.msInMinute;

        if (flag === -1 || flag === 2) {
            if (flag === -1 && diffMins + mins < 5)
                mins = 5 - diffMins;

            startDCopy.setMinutes(startDCopy.getMinutes() - mins);
        }

        if (flag > 0) {
            if (flag === 1 && mins >= diffMins)
                mins = diffMins - 5;

            endDCopy.setMinutes(endDCopy.getMinutes() - mins);
        }

        let from = this.getPercentFromTimes(start, startDCopy);

        if (flag === 2 && this._helper.dom.hasClass(target, "doctor") && target !== node.parentNode) {
            doctorNode = target;

            target.appendChild(node);

            const startNew = this._helper.date.fromStr(doctorNode.dataset.beginDateTime);
            const endNew = this._helper.date.fromStr(doctorNode.dataset.endDateTime);

            let changedTimes = false;

            if (this._helper.date.diffTime(endDCopy, endNew) > 0) {
                changedTimes = true;
                endDCopy = endNew;
                startDCopy = new Date(endDCopy.getTime());
                startDCopy.setMinutes(startDCopy.getMinutes() - diffMins);
            }
            else if (this._helper.date.diffTime(startNew, startDCopy) > 0) {
                changedTimes = true;
                startDCopy = startNew;
                endDCopy = new Date(startDCopy.getTime());
                endDCopy.setMinutes(endDCopy.getMinutes() + diffMins);
            }
            else if (startNew.getDate() !== startDCopy.getDate()) {
                changedTimes = true;

                const ss = new Date(startNew.getTime());
                ss.setHours(startDCopy.getHours(), startDCopy.getMinutes(), 0, 0);
                startDCopy = ss;

                const ee = new Date(ss.getTime());
                ee.setHours(endDCopy.getHours(), endDCopy.getMinutes(), 0, 0);
                endDCopy = ee;
            }

            from = this.getPercentFromTimes(startNew, startDCopy);

            if (changedTimes) {
                node.vStartD = startDCopy;
                node.vEndD = endDCopy;

                this.startY = pageY;
            }
        }

        if (from < 0 || endDCopy.getTime() > end.getTime())
            return;

        const docVis = this.currentDoctorVisits[doctorNode.dataset.idDate] || [];
        const startDTime = startDCopy.getTime();
        const endDTime = endDCopy.getTime();
        let hasIntersect = false;

        for (let i in docVis) {
            const { visId, beginTime, endTime } = docVis[i];
            if (visId === id)
                continue;

            hasIntersect = (startDTime < endTime && endDTime > beginTime);
            if (hasIntersect)
                break;
        }

        if (hasIntersect && flag < 2)
            return;

        const length = this.getPercentFromTimes(startDCopy, endDCopy);

        const doctorId = parseInt(doctorNode.dataset.id, 10);
        const cabinetId = parseInt(doctorNode.dataset.cabinetId, 10);

        if (node.vLastDate.getTime() === startDCopy.getTime() && node.vLastDateEnd.getTime() === endDCopy.getTime() && node.vLastDoctorId === doctorId && node.vLastCabinetId === cabinetId)
            return;

        this.setVizResizeStyle(node, from, length, startDCopy, endDCopy, hasIntersect);

        node.vHasIntersect = hasIntersect;
        node.vLastDate = startDCopy;
        node.vLastDateEnd = endDCopy;
        node.vLastDoctorId = doctorId;
        node.vLastCabinetId = cabinetId;
    }

    setVizResizeStyle(node, from, length, startDCopy, endDCopy, hasIntersect) {
        const diff = this.getShDiff(startDCopy, endDCopy);

        this._helper.dom.removeClass(node, allMins);
        this._helper.dom.addClass(node, "mins" + diff);
        this._helper.dom.addRemoveClass(node, "intersect", hasIntersect);

        this._helper.dom.styleProp(node, "start", from);
        this._helper.dom.styleProp(node, "length", length);

        const timeNode = node.querySelector(".timeN");
        const durNode = node.querySelector(".durN");

        const timeStr = this._helper.date.toTimeStr(startDCopy) + "-" + this._helper.date.toTimeStr(endDCopy);
        const timeStrVal = this._helper.date.formatTimeDuration(endDCopy, startDCopy);

        timeNode.innerText = timeStr;
        durNode.innerText = "(" + timeStrVal + ")";
    }

    editVisit(info, client) {
        this.props.openAddVisit(info, client, this.props.refreshVisits);
    }

    cancelVisitDialog(id, hasClient) {
        if (hasClient)
            return this._helper.openDialog("cancelApp", this.cancelVisit.bind(this, id));

        this._helper.confirm(
            { title: "app.cancelApp", message: this.tr("app.cancelAppConfirm") },
            this.cancelVisit.bind(this, id, { replaceReasonId: null, replaceReasonComment: "" })
        );
    }

    cancelVisit(id, { replaceReasonId, replaceReasonComment }) {
        this.props.updateVisit(id, {
            status: "WI_CANCELED",
            replaceReasonId,
            replaceReasonComment
        });
    }

    moveVisitToBuffer(id, client) {
        const addedToBuffer = this._helper.date.toStr();
        const fio = this._helper.string.formatFullName(client);
        const text = `^${this.tr("appointment.clientMoved").replace("$1", fio)}`;

        this.props.updateVisit(id, {
            status: "WI_BUFFER",
            addedToBuffer,
        }, this._helper.showNotify.bind(this._helper, "app.moveApp", text));
    }

    openClient(id, props) {
        this._helper.openClient(id, props);
    }

    checkShowTooltip(e) {
        const node = this._helper.dom.getParentByClass(e.target, "visit");
        const nodes = node ? Array.from(node.querySelectorAll(".checkT")) : [];

        const hasHidden = nodes.find(n => {
            if ((this._helper.dom.hasClass(n, "doctor-short") && n.scrollWidth > n.clientWidth) || n.clientHeight < 15)
                return true;

            return this._helper.dom.style(n, "display") === 'none';
        });

        if (!hasHidden)
            return;

        node.vTooltipText = "";
        node.dataset.tooltipMaxWidth = 300;
        nodes.forEach(n => {
            if (this._helper.dom.hasClass(n, "mainInfo"))
                return;

            node.vTooltipText += n.outerHTML;
        });

        this._helper.showTooltip(node);
    }

    async sendVisitSms(client, { beginDate, doctorId }) {
        const { id, fname, sname } = client;
        const date = this._helper.date.toTimeDateStr(beginDate);
        const docName = this._helper.getDoctorNameById(doctorId);
        const fio = this._helper.string.formatFullName(client, "short");

        const smsTemplate = this._helper.getCurrClinic()?.smsTemplateList?.find(it => it.name === "sms") || {};
        const templ = smsTemplate?.template || smsTemplate?.defaultTemplate || "";

        const text = templ.replace("ИмяОтчествоПациента", `${fname} ${sname}`.trim())
            .replace("ВремяИДатаВизита", `${date}`)
            .replace("ФИОДоктора", `${docName}`);

        this._helper.showLoading();
        const resp = await this._request.messages.sendClientSms(id, text);
        this._helper.hideLoading();

        const textNf = "^" + this.tr("notifications.visitSmsMessage").replace("$1", date).replace("$2", fio);
        this._helper.showRequestSuccess(resp, "notifications.visitSmsTitle", textNf);
    }

    /*async confirmAcceptance({ comment1, id }) {
        this.props.updateVisit(id, {
            comment1,
            callConfirmed: true
        });
    }*/

    getVisitInIcon(id, arrivalTime, leavingTime, clientInfo, isTop) {
        const cb = leavingTime ? null : () => {
            const time = this._helper.date.toStr();
            const key = !arrivalTime ? "arrivalTime" : "leavingTime";
            const info = { [key]: time };

            this.props.updateVisit(id, info);
        };

        const clMain = isTop ? " visitStatusTop" : "";

        if (arrivalTime && !leavingTime)
            return <VisitStatusInIcon className={"hand" + clMain} data-tooltip="app.inClinicStatus" onClick={cb} width={16} height={16} />;

        const cl = leavingTime ? " leaved" : " hand";
        const tt = leavingTime ? "app.outClinicStatus" : "app.noneClinicStatus";

        return <VisitStatusIcon className={"inState" + cl + clMain} data-tooltip={tt} onClick={cb} width={16} height={16} />;
    }

    stopDownEvFn() {
        return this._helper.stopEvent.bind(null);
    }

    getShDiff(startD, endD) {
        const diffMins = Math.abs(endD.getTime() - startD.getTime()) / this._helper.date.msInMinute;
        return this._helper.number.roundByFloor(diffMins, 5) || 5;
    }

    async prepareEvent(info, edit, onlyTheShift) {
        const { parent } = info;
        this._helper.showLoading();
        const infoShedResp = await this._request.doctorsSchedule.getScheduleByParentId(parent?.id);
        this._helper.hideLoading();
        const infoShed = infoShedResp?.data[0];

        this.confirmRegShifts(info, edit, infoShed, onlyTheShift);
    }

    confirmRegShifts(info, edit, infoShed, onlyTheShift) {
        const { beginDate, endDate } = infoShed;

        const bd = this._helper.date.toStr(new Date() > new Date(beginDate) ? null : beginDate, "DD MMMM");
        const ed = this._helper.date.toStr(endDate, "DD MMMM YYYY");

        let title = `${edit ? "Редактирование" : "Удаление"} регулярной смены`;
        let message = `Вы уверены что хотите ${edit ? "отредактировать" : "удалить"} регулярную смену? 
Будут ${edit ? "отредактированы" : "удалены"} все смены за период ${bd} - ${ed}`;
        if (onlyTheShift) {
            title = `Удаление дня из регулярной смены`;
            message = `Вы уверены что хотите удалить смену`;
        }

        this._helper.confirm({ title, message },
            edit ? this.editShifts.bind(this, info, false) : this.onDeleteVisit.bind(this, info, infoShed, onlyTheShift)
        );
    }

    async onDeleteVisit(info, infoShed, onlyTheShift) {
        const { domainId, doctorId, beginDate, endDate, parent, regular } = info;
        let repeatType = regular ? "WEEKLY" : "DAILY";
        this._helper.showLoading();
        const checkExist = await this._request.visits.checkExistVisits(domainId, doctorId, beginDate, endDate, repeatType);
        this._helper.hideLoading();

        if (!checkExist) {
            this._helper.showLoading();
            if (onlyTheShift && repeatType !== "DAILY") {
                const { beginDate: bd, endDate: ed } = infoShed;

                const beginDateEq = this._helper.date.equealDates(new Date(beginDate), new Date(bd));
                const endDateEq = this._helper.date.equealDates(new Date(endDate), new Date(ed));
                const begDate = this._helper.date.addDays(endDate, +1);
                const begDateFormat = this._helper.date.toDateServerStr(begDate);
                const finDate = this._helper.date.addDays(beginDate, -1);
                const finDateFormat = this._helper.date.toDateServerStr(finDate);

                if (!beginDateEq && !endDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { endDate: finDateFormat });
                    const infoData = { ...infoShed, beginDate: begDateFormat };
                    await this._request.doctorsSchedule.add(infoData);
                } else if (beginDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { beginDate: begDateFormat });
                } else if (endDateEq) {
                    await this._request.doctorsSchedule.update(parent?.id, { endDate: finDateFormat });
                }

            } else {
                const { beginDate: bd } = infoShed;
                if (new Date(this._helper.date.toStr(new Date(), "YYYY-MM-DD")) > new Date(this._helper.date.toStr(new Date(bd), "YYYY-MM-DD"))) {
                    const finDate = this._helper.date.addDays(beginDate, -1);
                    const finDateFormat = this._helper.date.toDateServerStr(finDate);
                    await this._request.doctorsSchedule.update(parent?.id, { endDate: finDateFormat });
                } else {
                    await this._request.doctorsSchedule.delete(parent?.id);
                }
            }

            this._helper.hideLoading();
            this.props.refreshVisits();
        } else {
            return this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("schedule.errorDeleted"),
                text: this.tr("schedule.visitsExisted"),
            });
        }

    }

    async editShifts(info, onlyTheShift) {
        if (this.props.openShift?.apply)
            this.props.openShift({ ...info, edit: true, onlyTheShift }, this.props.refreshVisits);
    }

    insertVisitTopActions(info, isEdit) {
        const { beginDate, regular } = info;


        const dotsItems = [
            { name: this.tr("schedule.allDoctorChanges"), onClick: null },
        ];

        const currDate = new Date();

        if (!(new Date(beginDate) < currDate.setHours(0, 0))) {
            const textDelete = regular ? "Удалить только эту смену" : "Удалить смену";
            const textEdit = regular ? "Редактировать только эту смену" : "Редактировать смену";

            dotsItems.push({ name: textEdit, onClick: this.editShifts.bind(this, info, true) });
            /*if (regular && !(new Date(regular) < currDate))
                dotsItems.push({ name: this.tr("schedule.editRegularShift"), onClick: this.prepareEvent.bind(this, info, true) });*/
            dotsItems.push({ name: textDelete, onClick: this.prepareEvent.bind(this, info, false, true) });
            if (regular && !(new Date(info.parent.endDate) < currDate))
                dotsItems.push({ name: this.tr("schedule.deleteRegularShift"), onClick: this.prepareEvent.bind(this, info, false, false) });
        }

        return (
            <div className="actionsTop flex centerV gap8" onMouseDown={this.stopDownEvFn()}>
                {!regular && <NorepeatIcon
                    className={"phoneIcon "}
                    data-tooltip={"Однодневная смена"}
                    width={16}
                    height={16}
                />}
                {isEdit && <ButtonIconSelect
                    name={"dots"}
                    type={"icon"}
                    items={dotsItems}
                    onClick={this._helper.hideTooltip.bind(this._helper)}
                />}
            </div>
        );
    }

    insertVisitBottomActions(client) {
        const { hasDuty, vipStatus, specNotes, status, personalData } = client;
        const { SPEC_NOTES } = personalData || {};

        const isbaned = status === "BLACK_LIST";
        const isNovice = status === "NOVICE";

        return (
            <div className="flex1 flex gap8">
                {!!hasDuty && <DebtIcon width={16} height={16} />}
                {!!vipStatus && <VipIcon width={16} height={16} />}
                {isbaned && <BanIcon width={16} height={16} />}
                {isNovice && <FirstVisitIcon width={16} height={16} />}
                {!!specNotes && <SpecialInfoIcon width={16} height={16} data-tooltip={SPEC_NOTES} />}
            </div>
        );
    }

    insertVisit(info, index, eaqualVisits = {}) {
        const { start, color, id, beginDate, endDate, doctorId, dateMode } = info;

        const eqKey = `${beginDate + endDate}`;
        if (!eaqualVisits[eqKey]?.toFixed)
            eaqualVisits[eqKey] = 0;
        else
            eaqualVisits[eqKey]++;

        const left = eaqualVisits[eqKey];

        const startD = this._helper.date.fromStr(beginDate);
        const endD = this._helper.date.fromStr(endDate);

        let from = null;
        let length = this.getPercentFromTimes(startD, endD);

        if (dateMode === "week") {
            from = this.getPercentFromTimes(this._helper.date.getTimeToday(`2024-01-04T08:00:00.000+00:00`), startD);
            from /= 15;
            length /= 15;
        } else {
            from = this.getPercentFromTimes(this._helper.date.getTimeToday(`2024-01-04T${start}.000+00:00`), startD);
        }

        const diff = this.getShDiff(startD, endD);

        const cl = ["visit", "flex", "pos", "abs", "rad8", "mins" + diff];
        const timeStr = this._helper.date.toTimeStr(startD) + "-" + this._helper.date.toTimeStr(endD);
        cl.push(color);
        cl.push(dateMode);

        return (<div
            key={`${index}_${beginDate}`}
            ref={el => this.visitsNodes[id] = el}
            data-begin-date={beginDate}
            data-end-date={endDate}
            className={cl.join(" ")}
            onClick={this._helper.stopEvent.bind(this._helper)}
            onMouseEnter={this.checkShowTooltip.bind(this)}
            onMouseLeave={this._helper.hideTooltip.bind(this._helper)}
            style={{
                "--start": from,
                "--length": length,
                "--left": left,
            }}
        >
            <div className="flex1 flex col gap8 hidden" >
                <div className="checkT mainInfo flex1 flex col hidden">
                    <div className="flex centerV gap8">
                        <div className="timeLabel flex1 flex gap8 text p1 lineHidden">
                            <div className="checkT timeN ">{timeStr}</div>
                            <div className="checkT doctor-short lineHidden">
                                {this._helper.string.formatFullName(globalThis.appPageView.getDoctorById(doctorId), "short")}
                            </div>
                        </div>
                        {this.insertVisitTopActions(info, info.isEdit)}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
